"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayOutput = exports.universalOutput = exports.nodeOutput = exports.browserOutput = void 0;
var output_1 = require("../src/octologger/output/output");
Object.defineProperty(exports, "browserOutput", { enumerable: true, get: function () { return output_1.browserOutput; } });
Object.defineProperty(exports, "nodeOutput", { enumerable: true, get: function () { return output_1.nodeOutput; } });
Object.defineProperty(exports, "universalOutput", { enumerable: true, get: function () { return output_1.universalOutput; } });
var array_1 = require("../src/octologger/output/array");
Object.defineProperty(exports, "arrayOutput", { enumerable: true, get: function () { return array_1.arrayOutput; } });
//# sourceMappingURL=preset.js.map